/**
 * Turf boundary with a pencil badge. One path set rather than two stacked
 * glyphs: the badge sits in an opening in the polygon, so it needs no opaque
 * background matched to one particular cell fill. Decorative — the button
 * renders the accessible name.
 */
export function BoundaryEditIcon({ className }: { className: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      {/* Polygon, opened at the bottom-right so the badge sits in clear space. */}
      <path d="M12 2.5 3 8.2v7.4l5.6 4.4h3.9" />
      <path d="M21 8.2 12 2.5" />
      {/* Pencil badge, drawn darker by the caller's text color at a smaller scale. */}
      <path d="M20.3 13.1a1.4 1.4 0 0 1 2 2l-5.1 5.1-2.7.7.7-2.7Z" />
    </svg>
  );
}
